import loadable from '@loadable/component';

const LazyLowResultsBanner = loadable(() => import('./LowResults'), {
    resolveComponent: (components) => components.LowResults,
});

const LazyNoResultsBanner = loadable(() => import('./NoResults'), {
    resolveComponent: (components) => components.NoResults,
});

export { LazyLowResultsBanner as LowResults };
export { LazyNoResultsBanner as NoResults };
